import React from 'react';

const Background = ({ children }) => {
    return (
        <div
            style={{ backgroundColor: '#f9f9f9', minHeight: '100vh', width: '100%' }}
            className="dark:bg-gray-800"
        >
            {children}
        </div>
    );
};

export default Background;
